import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header", true)!
  const _component_SendTestEmail = _resolveComponent("SendTestEmail")!
  const _component_SaveTemplateSettings = _resolveComponent("SaveTemplateSettings")!
  const _component_CloneTemplateName = _resolveComponent("CloneTemplateName")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      id: "email-preview",
      title: _ctx.templateName,
      "is-modal": _ctx.isModalDialog,
      "back-title": 
        _ctx.currentRouteName === _ctx.routeNames.EMAIL_TEMPLATE_BUILDER
          ? _ctx.$t('common.back')
          : _ctx.$t('common.backToEmailBuilder'),
      "menu-options": _ctx.templateOptions,
      "content-editable": true,
      "disable-restore": _ctx.disableRestoreVersionBtn,
      "show-clone-template": _ctx.cloneTemplate,
      "onModel:close": _ctx.handleModalClose,
      "onTitle:update": _ctx.onTemplateNameChange,
      "onRoute:back": _ctx.onBack,
      "onMenu:click": _ctx.onMenuItemClick,
      "onSave:click": _ctx.saveCampaignTemplate,
      "onSaveAsTemplate:click": _ctx.saveAsNewTemplate,
      "onVersion:restore": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('switchVersion'))),
      "onContact:click": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('contact:click')))
    }, null, 8 /* PROPS */, ["title", "is-modal", "back-title", "menu-options", "disable-restore", "show-clone-template", "onModel:close", "onTitle:update", "onRoute:back", "onMenu:click", "onSave:click", "onSaveAsTemplate:click"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.openTestEmailSideCover)
        ? (_openBlock(), _createBlock(_component_SendTestEmail, {
            key: 0,
            show: _ctx.openTestEmailSideCover,
            onClose: _cache[2] || (_cache[2] = () => (_ctx.openTestEmailSideCover = false)),
            class: "z-20 fonts-fallback",
            hasRSSElement: _ctx.hasRSSElement,
            templateId: _ctx.templateId,
            userId: _ctx.userId,
            locationId: _ctx.locationId,
            service: _ctx.service,
            customFieldsLocation: _ctx.customFields,
            customValuesLocation: _ctx.customValues,
            "schedule-details": _ctx.templateData,
            "sender-preferences": _ctx.senderPreferences,
            onUpdateSenderPreference: _cache[3] || (_cache[3] = (val)=>_ctx.$emit('updateSenderPreference',val))
          }, null, 8 /* PROPS */, ["show", "hasRSSElement", "templateId", "userId", "locationId", "service", "customFieldsLocation", "customValuesLocation", "schedule-details", "sender-preferences"]))
        : _createCommentVNode("v-if", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.openSaveTemplateSettings)
        ? (_openBlock(), _createBlock(_component_SaveTemplateSettings, {
            key: 0,
            show: _ctx.openSaveTemplateSettings,
            onClose: _cache[4] || (_cache[4] = () => (_ctx.openSaveTemplateSettings = false)),
            class: "z-20 fonts-fallback",
            templateId: _ctx.templateId,
            userId: _ctx.userId,
            locationId: _ctx.locationId,
            customFieldsLocation: _ctx.customFields,
            customValuesLocation: _ctx.customValues
          }, null, 8 /* PROPS */, ["show", "templateId", "userId", "locationId", "customFieldsLocation", "customValuesLocation"]))
        : _createCommentVNode("v-if", true)
    ])),
    (_ctx.showCloneTemplateName)
      ? (_openBlock(), _createBlock(_component_CloneTemplateName, {
          key: 0,
          "default-name": `${_ctx.templateName}-copy`,
          show: _ctx.showCloneTemplateName,
          "onClose:modal": _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCloneTemplateName = false)),
          "onClone:template": _cache[6] || (_cache[6] = name => _ctx.saveAsNewTemplate(name))
        }, null, 8 /* PROPS */, ["default-name", "show"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}